import React, { createContext, useContext, useState } from "react";

const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error("useTour must be used within a TourProvider");
  }
  return context;
};

export const TourProvider = ({ children }) => {
  const [activeTour, setActiveTour] = useState(null);
  const [completedTours, setCompletedTours] = useState(() => {
    const saved = localStorage.getItem("completedTours");
    return saved ? JSON.parse(saved) : [];
  });

  const startTour = (tourName) => {
    setActiveTour(tourName);
  };

  const endTour = (tourName) => {
    setActiveTour(null);
    if (!completedTours.includes(tourName)) {
      const updated = [...completedTours, tourName];
      setCompletedTours(updated);
      localStorage.setItem("completedTours", JSON.stringify(updated));
    }
  };

  const resetTours = () => {
    setCompletedTours([]);
    localStorage.removeItem("completedTours");
  };

  const isTourCompleted = (tourName) => {
    return completedTours.includes(tourName);
  };

  return (
    <TourContext.Provider
      value={{
        activeTour,
        startTour,
        endTour,
        resetTours,
        isTourCompleted,
        completedTours,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};